<template>
    <div>
        <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="1070px"
            @close="setDialogClosed" append-to-body>
            <el-container direction="vertical">
                <el-row style="width: 210px; margin-left: 22px">
                    <el-col :span="2">
                        <img style="
                      margin-left: -34px;
                      margin-top: 0px;
                      width: 30px;
                      height: 20px;
                    " :src="linkLine" />
                    </el-col>

                    <el-col :span="22">
                        <span style="margin-left: -25px">疾病行为危险因素信息</span>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 20px;">
                    <el-form size="mini" label-width="130px" inline="true">
                        <el-form-item label="*吸烟">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="*日均吸烟量/支">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="开始吸烟年龄/岁">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="戒烟年龄/岁">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="饮酒">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="饮食情况">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="规律活动">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="活动种类">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="活动频次">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="每次持续时间">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                    </el-form>
                </el-row>

                <el-row style="width: 210px; margin-left: 22px;margin-top: 10px;">
                    <el-col :span="2">
                        <img style="
                      margin-left: -34px;
                      margin-top: 0px;
                      width: 30px;
                      height: 20px;
                    " :src="linkLine" />
                    </el-col>

                    <el-col :span="22">
                        <span style="margin-left: -25px">并发症及并存临床情况</span>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 20px;">
                    <el-form size="mini" inline="true" label-width="180px">
                        <el-form-item label="*并发症类型">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="*该并发症首次出现时间">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                    </el-form>
                </el-row>

                <el-row style="width: 210px; margin-left: 22px;margin-top: 10px;">
                    <el-col :span="2">
                        <img style="
                      margin-left: -34px;
                      margin-top: 0px;
                      width: 30px;
                      height: 20px;
                    " :src="linkLine" />
                    </el-col>

                    <el-col :span="22">
                        <span style="margin-left: -25px">体格检查和实验室检查信息</span>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 20px;">
                    <el-form size="mini" inline="true" label-width="180px">
                        <el-form-item label="*身高(cm)">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="*体重(kg)">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                    </el-form>

                    <el-form size="mini" inline="true" label-width="180px">
                        <el-form-item label="*踝肱指数测定：左侧">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="右侧">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                    </el-form>

                    <el-form size="mini" inline="true" label-width="180px">
                        <el-form-item label="*血压：平均收缩压/舒张压">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="是否达标">
                            <el-radio-group>
                                <el-radio :label="0">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="*第1次测量收缩压/舒张压">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="是否达标">
                            <el-radio-group>
                                <el-radio :label="0">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="*第2次测量收缩压/舒张压">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="是否达标">
                            <el-radio-group>
                                <el-radio :label="0">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="*第3次测量收缩压/舒张压">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="是否达标">
                            <el-radio-group>
                                <el-radio :label="0">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>

                    <el-form size="mini" inline="true" label-width="180px">
                        <el-form-item label="*空腹血糖(mmol/L)">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="是否达标">
                            <el-radio-group>
                                <el-radio :label="0">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="类型">
                            <el-radio-group>
                                <el-radio :label="0">末梢血</el-radio>
                                <el-radio :label="1">血浆</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>

                    <el-form size="mini" inline="true" label-width="180px">
                        <el-form-item label="*餐后2h血糖(mmol/L)">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="是否达标">
                            <el-radio-group>
                                <el-radio :label="0">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="类型">
                            <el-radio-group>
                                <el-radio :label="0">末梢血</el-radio>
                                <el-radio :label="1">血浆</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>

                    <el-form size="mini" inline="true" label-width="180px">
                        <el-form-item label="*总胆固醇(mmol/L)">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="甘油三酯(mmol/L)">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="高密度脂蛋白胆固醇(mmol/L)">
                            <el-input placeholder=""></el-input>
                        </el-form-item>
                    </el-form>

                </el-row>

                <el-row>
                    <div style="float: right; margin-bottom:10px;">
                        <el-button size="small" type="primary" @click="onSubmit">确定保存</el-button>
                        <el-button size="small" @click="setDialogClosed">取消</el-button>
                    </div>
                </el-row>

                <annual-evaluation-result v-if="annualEvaluationResultVisible"
                                    ref="annualEvaluationResultRef"></annual-evaluation-result>

            </el-container>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment";
import imageLine from "@/assets/images/titleLine.png";
import annualEvaluationResult from "./annualEvaluationResult.vue";

export default {
    components:{ annualEvaluationResult },
    data() {
        return {
            showDialog: false,
            title: "年度综合评估",
            annualEvaluationResultVisible:false,
            list: null,
            listLoading: false,
            linkLine: imageLine
        };
    },
    methods: {
        // 编辑初始化页面内容
        async init(dataContext) {
            console.log(dataContext);
            this.showDialog = true;
            this.$nextTick(() => {
                this.getReportDetail(dataContext.id);
            });
        },
        // 关闭对话框触发
        setDialogClosed() {
            this.showDialog = false;
        },
        getParsedTime(time) {
            return moment(time).format("YYYY-MM-DD HH:mm");
        },
        getReportDetail(itemId) {

        },
        onSubmit() {
            var row = {
                id:1
            };
            this.patientsAnnualEvaluationResult(row);
        },
        //年度评估
        patientsAnnualEvaluationResult(row) {
            this.annualEvaluationResultVisible = true;
            this.$nextTick(() => {
                this.$refs["annualEvaluationResultRef"].init(row);
            });
        },
    },
};
</script>

<style lang="less" scoped></style>